// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"Ii","place_order_copy":"Ji","next_order_copy":"Ki","title_wrapper":"Li","get_it_now_row":"Mi","get_it_now_remaining_items":"Ni","get_it_now_remaining_items_mob":"Oi","order_summary":"Pi","additional_items":"Qi","account_content_slider":"Ri","ingredient_carousel":"Si","ingredient_carouselwrapper":"Ti","account_content_slide":"Ui","account_subscription_section_mob":"Vi","carouselwrapper":"Wi"};
    if(module.hot) {
      // 1714422952413
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  